import React, { useState } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { CategoriesRow } from './components/CategoriesRow';
import { FiltersBar } from './components/FiltersBar';
import { CouponList } from './components/CouponList';
import { HowItWorks } from './components/HowItWorks';
import { PartnersGrid } from './components/PartnersGrid';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { Toast } from './components/Toast';
import { RedeemModal } from './components/RedeemModal';
export function App() {
  const [showToast, setShowToast] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeFilter, setActiveFilter] = useState('newest');
  const handleCopyCode = coupon => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };
  const handleShowModal = coupon => {
    setSelectedCoupon(coupon);
    setShowModal(true);
  };
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow w-full max-w-4xl mx-auto px-4 pb-8" data-id="element-2">
        <HeroSection onClaimCode={handleCopyCode} data-id="element-3" />
        <CategoriesRow activeCategory={activeCategory} setActiveCategory={setActiveCategory} data-id="element-4" />
        <FiltersBar activeFilter={activeFilter} setActiveFilter={setActiveFilter} data-id="element-5" />
        <CouponList onCopyCode={handleCopyCode} onShowHowTo={handleShowModal} activeCategory={activeCategory} activeFilter={activeFilter} data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <PartnersGrid data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      {showToast && <Toast message="Code copied to clipboard" data-id="element-11" />}
      {showModal && <RedeemModal coupon={selectedCoupon} onClose={() => setShowModal(false)} data-id="element-12" />}
    </div>;
}